const ScheduleType = {
    free: 0,
    gettingReady: 1,
    study: 2,
    sleep: 3,
    family: 4,
    workOffice: 5,
    workHome: 6,
    commuting: 7,
    lifestyle: 8,
    other: 9
}

const ScheduleDay = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
}

let ScheduleItem = Backbone.Model.extend(
    {
        defaults: {
            type: ScheduleType.free,
            day: ScheduleDay.monday,
            startTime: 0,
            endTime: 0,
            lifestyleNo: 0,
            name: null,
        },

        getType: function () {
            return parseInt(this.get('type'));
        },
        getDay: function () {
            return parseInt(this.get('day'));
        },
        getStartTime: function () {
            return parseInt(this.get('startTime'));
        },
        getEndTime: function () {
            return parseInt(this.get('endTime'));
        },
        getDuration: function () {
            let endTime = this.getEndTime();
            let startTime = this.getStartTime();
            return endTime - startTime;
        },
        getLifestyleNo: function () {
            return parseInt(this.get('lifestyleNo'));
        },
        getName: function() {
            return this.get('name');
        },

        adjustTimes: function (startTime, endTime) {
            this.set('startTime', startTime);
            this.set('endTime', endTime);
        },

        updateFromDateTimeObjects: function (startDateTime, endDateTime) {
            function extractTime(date) {
                return (date.getHours() * 60) + date.getMinutes();
            }

            let day = startDateTime.getDay();
            let startTime = extractTime(startDateTime);
            let endTime = extractTime(endDateTime);

            this.set('day', day);
            this.set('startTime', startTime);
            this.set('endTime', endTime);
        }
    }
);

let ScheduleItemList = Backbone.Collection.extend({
    model: ScheduleItem
});

function CreateScheduleItemFromAttributes(attributes) {
    return new ScheduleItem(attributes);
}

function CreateScheduleItem(scheduleType, day, startTime, endTime, lifestyleNo) {
    lifestyleNo = nullIfUndefined(lifestyleNo);
    return new ScheduleItem({
        type: scheduleType,
        day: day,
        startTime: startTime,
        endTime: endTime,
        lifestyleNo: lifestyleNo
    });
}


function CreateScheduleItemFromDateTimeObjects(scheduleType, start, end, name) {
    name = nullIfUndefined(name);
    let scheduleItem = new ScheduleItem({type: scheduleType, name:name});
    scheduleItem.updateFromDateTimeObjects(start, end);
    return scheduleItem;
}
